import React from 'react';
import {
  Paper,
  Box,
  Typography,
  Alert,
  alpha,
  useTheme
} from '@mui/material';

interface RiskLevelBadgeProps {
  totalScore: number;
  maxScore?: number;
}

const RiskLevelBadge: React.FC<RiskLevelBadgeProps> = ({ 
  totalScore, 
  maxScore = 7 
}) => {
  const theme = useTheme();

  const getRiskLevel = (score: number) => {
    if (score <= 2) return { 
      level: 'Low Risk', 
      color: theme.palette.success.main, 
      bg: alpha(theme.palette.success.main, 0.1),
      severity: 'success' as const
    };
    if (score <= 4) return { 
      level: 'Moderate Risk', 
      color: theme.palette.warning.main, 
      bg: alpha(theme.palette.warning.main, 0.1),
      severity: 'warning' as const
    };
    return { 
      level: 'High Risk', 
      color: theme.palette.error.main, 
      bg: alpha(theme.palette.error.main, 0.1),
      severity: 'error' as const
    };
  };

  const riskLevel = getRiskLevel(totalScore);

  return (
    <Paper 
      elevation={2} 
      sx={{ 
        p: 3, 
        bgcolor: riskLevel.bg,
        border: `2px solid ${riskLevel.color}`
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="h6">Total ABCDE Score</Typography>
        <Typography variant="h4" sx={{ fontWeight: 700, color: riskLevel.color }}>
          {totalScore}/{maxScore}
        </Typography>
      </Box>
      <Alert severity={riskLevel.severity} sx={{ mb: 0 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          {riskLevel.level}
        </Typography>
      </Alert>
    </Paper>
  );
};

export default RiskLevelBadge;
